const prices = [
    {
        2: "€ 90",
        3: "€ 135",
        4: "€ 180",
        5: "€ 225",
        6: "€ 270"
    },
    {
        2: "€ 340",
        3: "€ 510",
        4: "€ 680",
        5: "€ 850",
        6: "€ 1020"
    }
];    

let price_wrapper = document.createElement('div');
    price_wrapper.innerHTML = 
    `<div class="meety-inline-stack price-wrapper"
        style="
            --meety-inline-stack-gap: 8px;
            --meety-inline-stack-wrap: nowrap;
            --meety-inline-stack-block-align: center;
            --meety-inline-stack-align: start;
            --meety-inline-stack-row-gap: 8px;
            --meety-inline-stack-width: 100%;
        "
        >
        <div
            class="meety-text"
            style="
            --meety-text-text-color: var(--meety-text-color);
            --meety-text-font-size: var(--meety-font-size-13);
            --meety-text-font-weight: var(--meety-font-weight-400);
            --meety-text-line-height: var(--meety-line-height-150);
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            text-align: left;
            width: initial;
            text-decoration: none;
            "
        ><strong>Price</strong>:     
        </div>
    </div>`;

function waitfor(condition , interval = 500){
    return new Promise(resolve => {
        const timer = setInterval(() => {
            const result = condition();

            if(result){
                clearInterval(timer);
                resolve(result);
            }
        }, interval);
    })
}    


// append price to the booking widget first view

const widgets = document.querySelectorAll('.shopify-app-block');

async function displayPrice(widget){
    const input = await waitfor(() => {
        const el = widget.querySelector('.meety-numner-input-value');
        return el && el.value ? el : null;
    });

    let index = Array.from(widgets).indexOf(widget); 

    widget.querySelector('#meety-book-component-container .meety-block-stack .meety-inline-grid:nth-child(2) .meety-number-input .meety-text:first-child').textContent = "How many guests will be attending?";
    widget.querySelector('#meety-book-component-container .meety-block-stack .meety-inline-grid:nth-child(2) .meety-number-input .meety-text:last-child').textContent = "Minimum of 2 guests is required.";

    const priceContainer = widget.querySelector(
        '.meety-card > .meety-scrollable #meety-book-component .meety-inline-grid'
    );

    if (!priceContainer) return;

    const wrapper = price_wrapper.cloneNode(true);
    wrapper.querySelector('.meety-text').innerHTML =
        `<strong>Price:</strong> ${prices[index][input.value]}`;

    priceContainer.append(wrapper);
} 

// show the discounted price on the booking widget 2nd view

async function initBookingWidget(widget) {

    const bookingBtn = await waitfor(() => {
        const e = widget.querySelector('#meety-schedule-book-booking-button');
        return e || null;
    });

    if (!bookingBtn) return;

    bookingBtn.addEventListener('click', async function () {
        console.log('Btn Clicked');
        const capacity = await waitfor(() => {
            console.log("Capacity is not resolving");
            return document.querySelector(
                '.meety-inline-grid > .meety-inline-stack:nth-child(3) .meety-text'
            );
            
        });

        if (!capacity) {
            console.log("Capacity not found");
            return;
        }
        console.log(capacity);

        const capacityNum = capacity.textContent.replace(/\D/g, "");

        const totalPrice = document.querySelector(
            '.meety-modal-content-main > .meety-box:nth-child(5) .meety-inline-grid .meety-inline-stack .meety-text'
        );

        if (!totalPrice) return;

        let index = Array.from(widgets).indexOf(widget); 

        if (prices[index][capacityNum]) {
            totalPrice.textContent = prices[index][capacityNum];
            
        }

        totalPrice.style.display = "block";
    });

}

// changed the appended price based on button click

async function initPriceChange(widget){
    const buttons = await waitfor(() => {
      const element = widget.querySelectorAll('.meety-icon-button');
      return element.length ? element : null;
    });

    buttons.forEach((item) => {
        item.addEventListener('click' , async function(){
            console.log("price clicked");
            const oldQuantity = widget.querySelector('.meety-numner-input-value').value;
            const newQuantity = await waitfor(() => {
                input = widget.querySelector('.meety-numner-input-value');
                newValue = Number(input.value);
                return  newValue !== Number(oldQuantity) ? newValue : null;
            })
            const quantity = newQuantity;
            let index = Array.from(widgets).indexOf(widget);
            widget.querySelector('.price-wrapper .meety-text').innerHTML = `<strong>Price:</strong> ${prices[index][quantity]}`;
        });
    }); 
}

widgets.forEach((widget) => {
    displayPrice(widget);
    initBookingWidget(widget);
    initPriceChange(widget);
});



// for read more in expereince box
jQuery(document).ready(function(){
    jQuery('.experience_box .content_box').slideUp();

    jQuery('.experience_box a.toggle_btn').click(function(e){
        e.preventDefault();
        let experience_wrapper = jQuery(this).closest('.experience_box');
        let content = experience_wrapper.find('.content_box');
        let toggleBtn = experience_wrapper.find('a.toggle_btn');
        let toggleBtn_wrapper = experience_wrapper.find('.exp_btn_group');

        if (content.is(':visible')){
            content.slideUp();
            toggleBtn.text('Read More');
            toggleBtn_wrapper.removeClass('mb-auto');
        }
        else{
            content.slideDown();
            toggleBtn.text('Read Less');
            toggleBtn_wrapper.addClass('mb-auto');

        }
    })
});

jQuery(document).ready(function(){
    let calendarWidget = jQuery('.experience_calandar .shopify-app-block');
    let expBtn = jQuery('.experience_btn');
    
    jQuery(calendarWidget[0]).addClass('show');

    expBtn.each((index, btn) => {
        jQuery(btn).click(function(){
            jQuery(this).addClass('clicked');
            jQuery('.experience_calandar .shopify-app-block').removeClass('show');
            jQuery(calendarWidget[index]).addClass('show');    
        })
    })
    
    
});













